import React from 'react';
import { SideBar } from '../../sidebar';
import HeaderBanner from '../../../common/HeaderBanner';
import {
  ArrowLeft,
  Save,
  Calendar,
  MapPin,
  User,
  Mail,
  Phone,
  Building,
  Clock,
  Shield,
  Download,
  Eye,
} from 'lucide-react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  getSiteVisitRegistrationById,
  updateSiteVisitRegistration,
  verifySiteVisitReg,
} from './services/siteVisitDetailsService';
import DataTable from 'react-data-table-component';
import { tableStyles } from '../../../../styles/components/js/tableStyle';

export class SiteVisitFormDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      name: '',
      email: '',
      mobile: '',
      company_number: '',
      status: 'N',
      project_id: null,
      training_date: '',
      training_time: '',
      visit_date: '',
      visit_time: '',
      verification_code: '',
      project: null,
      places: [],
      visitors: [],
      files: [],
      loading: false,
      submitting: false,
      hideSidebar: false,
    };
  }

  componentDidMount() {
    const pathParts = window.location.pathname.split('/');
    const id = pathParts[pathParts.length - 2];
    console.log('ID from URL:', id);

    if (id && id !== 'edit') {
      this.loadRegistrationData(id);
    } else {
      console.error('Invalid ID from URL');
      toast.error('Invalid registration ID');
    }
  }

  loadRegistrationData = async (registrationId) => {
    this.setState({ loading: true });
    try {
      const response = await getSiteVisitRegistrationById(registrationId);

      if (response.status && response.data) {
        const registration = response.data.registration || response.data;
        this.setState({
          id: registration.id,
          name: registration.name || '',
          email: registration.email || '',
          mobile: registration.mobile || '',
          company_number: registration.company_number || '',
          status: registration.status || 'N',
          project_id: registration.project_id,
          training_date: registration.training_date || '',
          training_time: registration.training_time || '',
          visit_date: registration.visit_date || '',
          visit_time: registration.visit_time || '',
          verification_code: registration.verification_code || '',
          project: registration.project || null,
          places: registration.places || [],
          visitors: registration.visitors || [],
          files: registration.files || [],
        });
      } else {
        toast.error('Failed to load registration data');
      }
    } catch (error) {
      console.error('Error loading registration:', error);
      toast.error('Error loading registration data');
    } finally {
      this.setState({ loading: false });
    }
  };

  // Improved Columns for Visitors Table with better justification
  getVisitorColumns() {
    return [
      {
        name: '#',
        width: '80px',
        minWidth: '80px',
        maxWidth: '80px',
        sortable: false,
        center: true,
        cell: (row, index) => (
          <div className="text-center" style={{ fontWeight: '500', color: '#495057' }}>
            {index + 1}
          </div>
        ),
      },
      {
        name: 'Visitor Name',
        selector: (row) => row.name,
        sortable: true,
        grow: 2,
        minWidth: '200px',
        cell: (row) => (
          <div
            style={{
              fontSize: '14px',
              fontWeight: '500',
              color: '#212529',
            }}
          >
            {row.name || '-'}
          </div>
        ),
      },
      {
        name: 'Civil ID',
        selector: (row) => row.civil_id,
        sortable: true,
        grow: 2,
        minWidth: '200px',
        cell: (row) => (
          <div
            style={{
              fontSize: '14px',
              fontWeight: '500',
              color: '#495057',
              fontFamily: 'monospace',
            }}
          >
            {row.civil_id || '-'}
          </div>
        ),
      },
    ];
  }

  // Improved Columns for Visit Places Table with better justification
  getPlacesColumns() {
    return [
      {
        name: '#',
        width: '80px',
        minWidth: '80px',
        maxWidth: '80px',
        sortable: false,
        center: true,
        cell: (row, index) => (
          <div className="text-center" style={{ fontWeight: '500', color: '#495057' }}>
            {index + 1}
          </div>
        ),
      },
      {
        name: 'Place Name',
        selector: (row) => row.place_name,
        sortable: true,
        grow: 2,
        minWidth: '250px',
        cell: (row) => (
          <div
            style={{
              fontSize: '14px',
              fontWeight: '500',
              color: '#212529',
            }}
          >
            {row.place_name || '-'}
          </div>
        ),
      },
      {
        name: 'Address',
        selector: (row) => row.address,
        sortable: true,
        grow: 3,
        minWidth: '300px',
        cell: (row) => (
          <div
            style={{
              fontSize: '14px',
              color: '#6c757d',
              lineHeight: '1.4',
            }}
          >
            {row.address || 'N/A'}
          </div>
        ),
      },
    ];
  }

  // Improved Columns for Files Table with better justification
  getFilesColumns() {
    return [
      {
        name: '#',
        width: '80px',
        minWidth: '80px',
        maxWidth: '80px',
        sortable: false,
        center: true,
        cell: (row, index) => (
          <div className="text-center" style={{ fontWeight: '500', color: '#495057' }}>
            {index + 1}
          </div>
        ),
      },
      {
        name: 'File Name',
        selector: (row) => row.image,
        sortable: true,
        grow: 3,
        minWidth: '250px',
        cell: (row) => {
          const fileName = row.image?.split('/').pop() || '-';
          return (
            <div
              style={{
                fontSize: '14px',
                color: '#212529',
                wordBreak: 'break-word',
              }}
            >
              {fileName}
            </div>
          );
        },
      },
      {
        name: 'Type',
        selector: (row) => row.image?.split('.').pop(),
        sortable: true,
        width: '120px',
        minWidth: '120px',
        maxWidth: '120px',
        center: true,
        cell: (row) => {
          const fileType = row.image?.split('.').pop()?.toUpperCase() || 'N/A';
          return (
            <span
              className="badge"
              style={{
                backgroundColor: '#6c757d',
                color: 'white',
                padding: '4px 8px',
                borderRadius: '4px',
                fontSize: '12px',
                fontWeight: '500',
              }}
            >
              {fileType}
            </span>
          );
        },
      },
      {
        name: 'Actions',
        width: '150px',
        minWidth: '150px',
        maxWidth: '150px',
        center: true,
        cell: (row) => (
          <div className="btn-group btn-group-sm" style={{ gap: '4px' }}>
            <button
              type="button"
              className="btn-new btn-action"
              onClick={() => this.handleViewFile(row.image)}
              title="View File"
            >
              <Eye size={14} />
            </button>
            <button
              type="button"
              className="btn-new btn-action"
              onClick={() => this.handleDownloadFile(row.image, row.image?.split('/').pop())}
              title="Download File"
            >
              <Download size={14} />
            </button>
          </div>
        ),
      },
    ];
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ submitting: true });

    // Validate required fields
    if (!this.state.name || !this.state.email || !this.state.mobile) {
      toast.error('Please fill all required fields');
      this.setState({ submitting: false });
      return;
    }

    // Prepare form data
    const formData = {
      name: this.state.name,
      email: this.state.email,
      mobile: this.state.mobile,
      company_number: this.state.company_number,
      status: this.state.status,
      training_date: this.state.training_date,
      training_time: this.state.training_time,
      visit_date: this.state.visit_date,
      visit_time: this.state.visit_time,
    };

    try {
      const response = await updateSiteVisitRegistration(this.state.id, formData);

      if (response.status || response.success) {
        toast.success(response.message || 'Registration updated successfully');
        // Refresh the data
        this.loadRegistrationData(this.state.id);
      } else {
        toast.error(response.message || 'Registration update failed');
      }
    } catch (error) {
      console.error('Error updating registration:', error);
      toast.error('Something went wrong while updating the registration');
    } finally {
      this.setState({ submitting: false });
    }
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleStatusChange = (e) => {
    this.setState({ status: e.target.value });
  };

  submitVerificationCode = async (e) => {
    const formData = { verification_code: this.state.verification_code };
    try {
      const response = await verifySiteVisitReg(this.state.id, formData);

      if (response.status || response.success) {
        toast.success(response.message || 'Verification successfully');
        // Refresh the data
        this.loadRegistrationData(this.state.id);
      } else {
        toast.error(response.message || 'Verification failed');
      }
    } catch (error) {
      console.error('Error updating registration:', error);
      toast.error(error.message);
    } finally {
      this.setState({ submitting: false });
    }
  };

  handleViewFile = (fileUrl) => {
    const fullUrl = `${process.env.REACT_APP_IMAGE_URL}${fileUrl}`;
    window.open(fullUrl, '_blank');
  };

  handleDownloadFile = (fileUrl, fileName) => {
    const fullUrl = `${process.env.REACT_APP_IMAGE_URL}${fileUrl}`;
    const link = document.createElement('a');
    link.href = fullUrl;
    link.download = fileName || 'document';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  render() {
    const {
      name,
      email,
      mobile,
      company_number,
      status,
      training_date,
      training_time,
      visit_date,
      visit_time,
      verification_code,
      project,
      places,
      visitors,
      files,
      submitting,
    } = this.state;

    return (
      <React.Fragment>
        <HeaderBanner
          title="Site Visit Registration Details"
          subtitle="Update registration information and schedule"
        />

        <section className="mt-5 site-visit-details-page">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="expand-dashboard">
                        <span
                          style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                          onClick={() => {
                            this.setState({
                              hideSidebar: !this.state.hideSidebar,
                            });
                          }}
                        >
                          {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                          {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      <Link to="/site-visit-requests" className="button1 button1-primary">
                        <ArrowLeft size={16} />
                        Back to List
                      </Link>
                    </div>
                  </div>

                  <div className="card-body">
                    <div className="site-visit-registration-details">
                      <form onSubmit={this.handleSubmit}>
                        {/* Verification Code Section */}
                        {status === 'WS' && (
                          <div className="form-section">
                            <h3 className="section-title">
                              <Shield size={20} className="me-2" />
                              Verification Code
                            </h3>
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="form-label">Verification Code</label>
                                  <div className="input-group">
                                    <span className="input-group-text">
                                      <Shield size={16} />
                                    </span>
                                    <input
                                      type="text"
                                      name="verification_code"
                                      value={verification_code}
                                      onChange={this.handleInputChange}
                                      className="form-control"
                                      placeholder="Enter 4-digit verification code"
                                      maxLength="4"
                                      pattern="[0-9]{4}"
                                      title="Please enter a 4-digit number"
                                      disabled={submitting}
                                    />
                                    <button
                                      type="button"
                                      className="button1 button1-primary"
                                      onClick={this.submitVerificationCode}
                                      disabled={submitting}
                                    >
                                      Verify
                                    </button>
                                  </div>
                                  <small className="form-text text-muted">
                                    Enter a 4-digit verification code. This code will be used to
                                    verify site visit completion.
                                  </small>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="alert alert-info">
                                  <strong>Note:</strong>
                                  <ul className="mb-0 mt-2">
                                    <li>Generate a code when setting site visit date</li>
                                    <li>Use this code to mark visit as completed</li>
                                    <li>Code should be shared with visitor via whatsapp</li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {project && (
                          <div className="form-section">
                            <h3 className="section-title">Project Information</h3>
                            <div className="card bg-light">
                              <div className="card-body">
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="info-item">
                                      <strong>Project Name:</strong>
                                      <span>{project.project_name}</span>
                                    </div>
                                    <div className="info-item">
                                      <strong>Description:</strong>
                                      <span>{project.description}</span>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="info-item">
                                      <strong>Start Date:</strong>
                                      <span>{new Date(project.start_at).toLocaleString()}</span>
                                    </div>
                                    <div className="info-item">
                                      <strong>End Date:</strong>
                                      <span>{new Date(project.end_at).toLocaleString()}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Registration Information */}
                        <div className="form-section">
                          <h3 className="section-title">Registration Information</h3>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="form-label">Full Name *</label>
                                <div className="input-group">
                                  <span className="input-group-text">
                                    <User size={16} />
                                  </span>
                                  <input
                                    type="text"
                                    name="name"
                                    value={name}
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                    placeholder="Enter full name"
                                    required
                                    disabled={submitting}
                                  />
                                </div>
                              </div>

                              <div className="form-group">
                                <label className="form-label">Email *</label>
                                <div className="input-group">
                                  <span className="input-group-text">
                                    <Mail size={16} />
                                  </span>
                                  <input
                                    type="email"
                                    name="email"
                                    value={email}
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                    placeholder="Enter email address"
                                    required
                                    disabled={submitting}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="form-label">Mobile Number *</label>
                                <div className="input-group">
                                  <span className="input-group-text">
                                    <Phone size={16} />
                                  </span>
                                  <input
                                    type="tel"
                                    name="mobile"
                                    value={mobile}
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                    placeholder="Enter mobile number"
                                    required
                                    disabled={submitting}
                                  />
                                </div>
                              </div>

                              <div className="form-group">
                                <label className="form-label">Company Number</label>
                                <div className="input-group">
                                  <span className="input-group-text">
                                    <Building size={16} />
                                  </span>
                                  <input
                                    type="text"
                                    name="company_number"
                                    value={company_number}
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                    placeholder="Enter company number"
                                    disabled={submitting}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Training Schedule */}
                        <div className="form-section">
                          <h3 className="section-title">Training Schedule</h3>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="form-label">Training Date</label>
                                <div className="input-group">
                                  <span className="input-group-text">
                                    <Calendar size={16} />
                                  </span>
                                  <input
                                    type="date"
                                    name="training_date"
                                    value={training_date}
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                    disabled={submitting}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="form-label">Training Time</label>
                                <div className="input-group">
                                  <span className="input-group-text">
                                    <Clock size={16} />
                                  </span>
                                  <input
                                    type="time"
                                    name="training_time"
                                    value={training_time}
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                    disabled={submitting}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Site Visit Schedule */}
                        <div className="form-section">
                          <h3 className="section-title">Site Visit Schedule</h3>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="form-label">Visit Date</label>
                                <div className="input-group">
                                  <span className="input-group-text">
                                    <Calendar size={16} />
                                  </span>
                                  <input
                                    type="date"
                                    name="visit_date"
                                    value={visit_date}
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                    disabled={submitting}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="form-label">Visit Time</label>
                                <div className="input-group">
                                  <span className="input-group-text">
                                    <Clock size={16} />
                                  </span>
                                  <input
                                    type="time"
                                    name="visit_time"
                                    value={visit_time}
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                    disabled={submitting}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Visit Places DataTable */}
                        {places && places.length > 0 && (
                          <div className="form-section">
                            <h3 className="section-title">
                              <MapPin size={20} className="me-2" />
                              Visit Places ({places.length})
                            </h3>
                            <div
                              className="table-container"
                              style={{ borderRadius: '8px', overflow: 'hidden' }}
                            >
                              <DataTable
                                columns={this.getPlacesColumns()}
                                data={places}
                                customStyles={tableStyles}
                                highlightOnHover
                                noHeader
                                responsive
                              />
                            </div>
                          </div>
                        )}

                        {/* Visitors DataTable */}
                        {visitors && visitors.length > 0 && (
                          <div className="form-section">
                            <h3 className="section-title">
                              <User size={20} className="me-2" />
                              Visitors List ({visitors.length})
                            </h3>
                            <div
                              className="table-container"
                              style={{ borderRadius: '8px', overflow: 'hidden' }}
                            >
                              <DataTable
                                columns={this.getVisitorColumns()}
                                data={visitors}
                                customStyles={tableStyles}
                                highlightOnHover
                                noHeader
                                responsive
                              />
                            </div>
                          </div>
                        )}

                        {/* Civil ID Files DataTable */}
                        {files && files.length > 0 && (
                          <div className="form-section">
                            <h3 className="section-title">
                              <Download size={20} className="me-2" />
                              Civil ID Files ({files.length})
                            </h3>
                            <div
                              className="table-container"
                              style={{ borderRadius: '8px', overflow: 'hidden' }}
                            >
                              <DataTable
                                columns={this.getFilesColumns()}
                                data={files}
                                customStyles={tableStyles}
                                highlightOnHover
                                noHeader
                                responsive
                              />
                            </div>
                          </div>
                        )}

                        {/* Form Actions */}
                        <div className="form-actions mt-4 pt-4 border-top">
                          <div className="d-flex justify-content-end gap-3">
                            <Link
                              to="/site-visit-requests"
                              className="btn btn-secondary"
                              disabled={submitting}
                            >
                              Cancel
                            </Link>
                            <button type="submit" className="btn btn-primary" disabled={submitting}>
                              <Save size={16} />
                              {submitting ? 'Updating...' : 'Update Registration'}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
